import React from 'react'
import './NavBar.css'
import { setActivePane, paneOpts, saveToGA } from '../../../actions'
import i18n from '../../../i18n'
import { useSelector, useDispatch } from 'react-redux'

// Provides options rows for the FundList
const NavBar = () => {
  const dispatch = useDispatch()

  const activePane = useSelector(state => state.params.activePane)

  const setActivePaneAndSave = (val) => {
    dispatch(setActivePane(val))
    dispatch(saveToGA(val))
  }

  return (
    <div className='nav-bar row listoptions'>
      <div className='col-md-12 col-sm-12 types'>
        <button onClick={() => setActivePaneAndSave(paneOpts.metrics)} type='button' className={'navButton ' + (activePane === paneOpts.metrics ? 'isselected' : 'notselected')}>
          {i18n.t('Key Metrics')}
        </button>

        <button onClick={() => setActivePaneAndSave(paneOpts.chars)} type='button' className={'navButton ' + (activePane === paneOpts.chars ? 'isselected' : 'notselected')}>
          {i18n.t('Characteristics')}
        </button>
        
        <button onClick={() => setActivePaneAndSave(paneOpts.expos)} type='button' className={'navButton ' + (activePane === paneOpts.expos ? 'isselected' : 'notselected')}>
          {i18n.t('Exposures')}
        </button>

        <button onClick={() => setActivePaneAndSave(paneOpts.factors)} type='button' className={'navButton ' + (activePane === paneOpts.factors ? 'isselected' : 'notselected')}>
          {i18n.t('Factors')}
        </button>

        <button onClick={() => setActivePaneAndSave(paneOpts.perf)} type='button' className={'navButton ' + (activePane === paneOpts.perf ? 'isselected' : 'notselected')}>
          {i18n.t('Performance')}
        </button>
        
        <button onClick={() => setActivePaneAndSave(paneOpts.details)} type='button' className={'navButton ' + (activePane === paneOpts.details ? 'isselected' : 'notselected')}>
          {i18n.t('Details')}
        </button>
      </div>
    </div>
  )
}

export default NavBar
